angular.module('spaceChat.client')
  .directive('spaceChatClientModalsInjector', [function(){
    return {
      controller: 'spaceChatClientModalsInjectorCtrl',
      restrict: 'E',
      scope: true,
      templateUrl: 'ihestia-widgets-templates-app/spaceChat/client/modalsInjector.tpl.html'
    };
  }]);
